import {FaTimes} from "react-icons/fa";

export default function EditBudgetModal({
  formData,
  handleStartDateChange,
  handleInputChange,
  handleSaveEdit,
  onClose,
}) {
  return (
    <div className="modal-overlay-agr">
      <div className="modal-content-agr">
        <button className="close-btn-agr" onClick={onClose}>
          <FaTimes />
        </button>
        <h3>Edit Anggaran</h3>

        <div className="modal-body-agr">
          <div className="form-group-agr">
            <label>Start Date:</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleStartDateChange}
            />
          </div>

          <div className="form-group-agr">
            <label>End Date (+30 hari):</label>
            <input type="date" name="endDate" value={formData.endDate} readOnly />
          </div>

          <div className="form-group-agr">
            <label>Makanan & Kebutuhan Rumah Tangga:</label>
            <input
              type="number"
              name="makanan"
              value={formData.makanan}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Transportasi:</label>
            <input
              type="number"
              name="transportasi"
              value={formData.transportasi}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Konektivitas:</label>
            <input
              type="number"
              name="konektivitas"
              value={formData.konektivitas}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Hiburan:</label>
            <input
              type="number"
              name="hiburan"
              value={formData.hiburan}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Tagihan & Lainnya:</label>
            <input
              type="number"
              name="tagihan"
              value={formData.tagihan}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <button className="btn save-btn" onClick={handleSaveEdit}>
            Simpan Perubahan
          </button>
        </div>
      </div>
    </div>
  );
}